export default __webpack_public_path__ + "static/media/logo.30f6da1b.svg";